import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { AssistantsScreen } from "../../screens/settings/AssistantsScreen.tsx";

/** `/settings/assistants`: the AI assistants connected to the company. */
export const Route = createFileRoute("/_app/settings/assistants")({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.prefetchQuery(actions.queryOptions("agents.listConnections", {})),
      context.queryClient.prefetchQuery(actions.queryOptions("agents.setupInfo", {})),
    ]),
  component: AssistantsScreen,
});
